import { useEffect, useRef } from "react";
import { subscribeToNotifications } from "../api/notificationStream";

export default function useBotNotifications(botId, { topic, onRefresh, onEvent }) {
  const callbacks = useRef({ onRefresh, onEvent });
  callbacks.current = { onRefresh, onEvent };

  useEffect(() => {
    if (!botId) return undefined;
    let stopped = false;
    let refreshing = false;
    let pending = false;
    let timer;
    const refresh = async () => {
      if (stopped) return;
      pending = true;
      if (refreshing) return;
      refreshing = true;
      try {
        while (pending && !stopped) {
          pending = false;
          await callbacks.current.onRefresh();
        }
      } catch (error) {
        console.error("Notification-triggered refresh failed:", error);
      } finally {
        refreshing = false;
      }
    };
    const schedule = () => {
      clearTimeout(timer);
      timer = setTimeout(refresh, 150);
    };
    const unsubscribe = subscribeToNotifications(String(botId), (event) => {
      if (event.type === "connected" || event.type === "resync") {
        schedule();
      } else if (event.type?.startsWith(`${topic}.`)) {
        callbacks.current.onEvent?.(event);
        schedule();
      }
    });
    const recover = () => { if (!document.hidden) schedule(); };
    window.addEventListener("focus", recover);
    window.addEventListener("online", recover);
    document.addEventListener("visibilitychange", recover);
    const interval = setInterval(recover, 60000);
    return () => {
      stopped = true;
      clearTimeout(timer);
      clearInterval(interval);
      unsubscribe();
      window.removeEventListener("focus", recover);
      window.removeEventListener("online", recover);
      document.removeEventListener("visibilitychange", recover);
    };
  }, [botId, topic]);
}
